module.exports = __webpack_public_path__ + "media/src/application/media/default_user-d360f41d60d6c79b2eea8ae6a486dc40.jpg";